module.exports = "<button [type]=\"type\" class=\"app-button\" [ngClass]=\"'app-button--' + style\">\n  <ng-content></ng-content>\n</button>\n"